export enum Animation {
    SlideIn = 'slideIn',
    SlideOut = 'slideOut'
}
